<template>
    <div class="song-list-page">
        <RsStep :active="1" :steps="['创建专辑', '上传歌曲', '提交审核']"></RsStep>
        <div class="m-t-4" v-loading="dataLoading">
            <div class="tools-bar">
                <p v-if="songList.length > 0">按住鼠标可拖动排序</p>
                <p v-else></p>
                <el-button v-if="!isDelete" type="primary" @click="addTrack">
                    <svg-icon icon-class="add_music"></svg-icon>
                    添加歌曲
                </el-button>
            </div>
            <SongList
                ref="songList"
                v-if="songList.length > 0"
                :list="songList"
                :isDelete="isDelete"
                @onSort="updateSort"
                @onDelete="delSong"
                @onEdit="editTrack"
            ></SongList>
            <NoData v-else title="暂时未添加歌曲" text="点击按钮添加歌曲">
                <template slot="btns">
                    <el-button type="info" @click="goBack()">上一步</el-button>
                </template>
            </NoData>
            <div class="m-t-8" v-if="songList.length > 0" style="text-align: center">
                <el-button v-if="isCanEdit" type="info" @click="goBack()">上一步</el-button>
                <el-button v-if="isCanEdit && albumId && songList.length > 0" type="primary" @click="showChannelDialog()" :loading="btnLoading">
                    提交审核
                </el-button>
            </div>
        </div>
        <ChannelDialog :visible.sync="visible" @onData="onChannelData"></ChannelDialog>
        <!-- 解决同时修改问题 -->
        <el-dialog
            title="提示"
            :visible.sync="lockDialogVisible"
            width="500px"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :append-to-body="true"
            center
        >
            <div style="line-height: 1.5; margin-bottom: 20px;" v-if="lockAlbumInfo.albumName">
                <span>{{ lockAlbumInfo.firstMsg }}</span>
                <template v-if="lockAlbumInfo.isToAlbum">
                    <el-link href :underline="false" type="primary" @click.prevent="toAlbumInfo(lockAlbumInfo.albumId, lockAlbumInfo.cpId)" style="color:#409EF7!important">
                        《{{ lockAlbumInfo.albumName }}》
                    </el-link>
                </template>
                <template v-else>
                    <span>《{{ lockAlbumInfo.albumName }}》</span>
                </template>
                <span>{{ lockAlbumInfo.endMsg }}</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="lockDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import SongList from '../components/SongList';
import ChannelDialog from '../components/ChannelDialog';

export default {
    props: {
        albumId: {
            type: [Number, String],
            default: '',
        },
    },
    components: {ChannelDialog, SongList},
    data() {
        return {
            dataLoading: false,
            data: null,
            songList: [],
            redirect: this.$route.query.redirect,
            btnLoading: false,
            // 专辑状态 | 未提交 10、待审核 11、 审核通过 12、审核未通过 13、修改中 14、已删除 15、修改待审核 16
            status: 10,
            statusMsg: '',
            excludeSpIds: [],
            visible: false,
            throttledSubmit: null, // 节流提交函数
            lockDialogVisible: false,
            lockAlbumInfo: {
                firstMsg: '',
                albumName: '',
                endMsg: '',
                albumId: null,
                cpId: null,
                isToAlbum: false
            }
        };
    },
    computed: {
        // 专辑是否可以修改（未提交、审核未通过、修改中状态下允许修改）
        isCanEdit() {
            return this.status === 10 || this.status === 13 || this.status === 14;
        },
        ifLimitAlbumForShowStart() {
            return this.$store.state.userData && this.$store.state.userData.ifLimitAlbumForShowStart;
        },
        isDelete() {
            const {hasAuditPassRecord} = this.$route.query;
            return hasAuditPassRecord && hasAuditPassRecord == 'true' ? true : false;
        },
    },
    mounted() {
        this.getDataList();
        this.throttledSubmit = this.$utils.throttle(this.commit, 3000);
    },
    methods: {
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.replace({
                    path: this.redirect,
                    query: {
                        hasAuditPassRecord: this.$route.query.hasAuditPassRecord,
                    },
                });
            } else {
                this.$router.go(-1);
            }
        },
        //获取歌曲列表
        getDataList() {
            this.dataLoading = true;
            this.$request({
                url: '/newAlbumTrack/view/list',
                method: 'GET',
                params: {albumId: this.albumId},
            })
                .then((res) => {
                    //处理成功回调
                    const {state, msg, result} = res.data;
                    if (state) {
                        this.data = result;
                        this.songList = (result.cdList && result.cdList[0] && result.cdList[0].trackList) || [];
                        this.status = result.albumVo.album.status;
                        this.statusMsg = res.data.result.alertInfo;

                        this.$nextTick(() => {
                            if (this.$refs['songList']) this.$refs['songList'].drag(); // 启动拖动排序
                        });
                    } else {
                        return this.$message.error(msg || '获取歌曲列表失败');
                    }
                })
                .catch(() => {
                    this.$message.error('获取歌曲列表失败,请重试');
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //排序
        updateSort(songList) {
            this.$request({
                url: '/album/up/sort',
                method: 'post',
                data: {
                    albumId: this.albumId,
                    albumTracks: songList,
                },
                formData: false,
            })
                .then((res) => {
                    //处理成功回调
                    const {state, msg} = res.data;
                    if (state && state == 1) {
                        this.$message.success('排序成功');
                    } else {
                        return this.$message.error(msg || '操作失败');
                    }
                })
                .catch(() => {
                    this.$message.error('操作失败,请重试');
                })
                .finally(() => {
                    this.getDataList();
                });
        },
        //新增歌曲
        addTrack() {
            this.$router.push({
                path: `/manage/album/trackInfo/${this.albumId}`,
            });
        },
        //编辑歌曲
        editTrack(track) {
            this.$request({
                url: 'track/ifLock',
                method: 'GET',
                params: {trackId: track.id, albumId: this.albumId},
            })
                .then((res) => {
                    //处理成功回调
                    if (!Object.keys(res.data.result).length) {
                        this.$router.push({path: `/manage/album/trackInfo/${this.albumId}/${track.id}`});
                    } else {
                        const {albumName, albumId, lockReason} = res.data.result;
                        /**
                         * lockReason：锁原因
                         * 0:未知原因
                         * 1:修改中
                         * 2:审核中
                         * 3:审核失败
                         */
                        switch (lockReason) {
                            case 0:
                                this.lockAlbumInfo = {
                                    firstMsg: '该歌曲所在专辑',
                                    albumName,
                                    endMsg: '被锁定，请联系管理员强制释放',
                                    albumId,
                                    cpId: this.cpId,
                                    isToAlbum: false
                                };
                                break;
                            case 1:
                                this.lockAlbumInfo = {
                                    firstMsg: '该歌曲正在专辑',
                                    albumName,
                                    endMsg: '修改中，请前往该专辑继续修改',
                                    albumId,
                                    cpId: this.cpId,
                                    isToAlbum: true
                                };
                                break;
                            case 2:
                                this.lockAlbumInfo = {
                                    firstMsg: '该歌曲所在专辑',
                                    albumName,
                                    endMsg: '已提交审核，请等待审核结束后再修改',
                                    albumId,
                                    cpId: this.cpId,
                                    isToAlbum: false
                                };
                                break;
                            case 3:
                                this.lockAlbumInfo = {
                                    firstMsg: '该歌曲所在专辑',
                                    albumName,
                                    endMsg: '审核驳回后仍保留草稿修改，请前往该专辑处理',
                                    albumId,
                                    cpId: this.cpId,
                                    isToAlbum: true
                                };
                                break;
                        }
                        this.lockDialogVisible = true;
                        return false;
                    }
                })
                .catch(() => {
                    this.$message.error('获取歌曲信息失败,请重试');
                })
                .finally(() => {});
            
        },
        toAlbumInfo(albumId) {
            this.lockDialogVisible = false;
            this.$router.push({
                path: `/manage/album/detail/${albumId}`
            });
        },
        // 删除专辑下歌曲
        delSong(track) {
            this.$confirm('删除现有歌曲，将丢失已经填写好的歌曲信息，确定要删除吗？', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false,
            })
                .then(() => {
                    const albumId = this.albumId;
                    const trackId = track.id;
                    this.$request({
                        url: '/track/delete',
                        method: 'POST',
                        data: {albumId: albumId, trackId: trackId},
                    })
                        .then((res) => {
                            const {state, msg} = res.data;
                            if (state) {
                                this.getDataList();
                            } else {
                                this.$message.error(msg || '请求失败');
                            }
                        })
                        .catch(() => {
                            this.$message.error('请求错误');
                        })
                        .finally(() => {});
                })
                .catch(() => {});
        },
        onChannelData(spIds) {
            this.excludeSpIds = spIds;
            this.throttledSubmit();
        },
        showChannelDialog() {
            if (this.ifLimitAlbumForShowStart == 1 || this.data.albumVo.album.ifOnlyReleaseSs == 1) {
                //未付费秀动用户直接提交
                this.throttledSubmit();
            } else {
                this.visible = true;
            }
        },
        //提交审核
        async commit() {
            const {songList} = this;
            let isSource = true;
            songList.forEach((element) => {
                if (!element.path) isSource = false;
            });
            if (!isSource) return this.$message.error('歌曲源文件存在缺失，不能进行审核提交');
            this.btnLoading = true;
            this.$request({
                url: '/album/up/commit_album_forshowstart',
                method: 'POST',
                data: {
                    albumId: this.albumId,
                    excludeSpIds: this.excludeSpIds.toString(),
                },
                formData: true,
            }).then((res) => {
                //处理成功回调
                const {state, msg, result} = res.data;
                if (result?.alertMessage) {
                    this.$message.warning(result.alertMessage);
                }
                if (state && state == 1) {
                    this.$router.push({
                        path: `/manage/album/info/${this.albumId}/success`,
                    });
                } else {
                    this.btnLoading = false;
                    return this.$message.error(msg || '操作失败');
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.song-list-page {
    .tools-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
            color: $-text-500;
        }
    }
}
</style>
